import React, { Fragment } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/quickscan/quickscan_info.webp';
import MKBImage from '../../images/sectoren/smb_image.jpg';
import ScaleUpImage from '../../images/sectoren/scaleup_image.jpg';
import MSPImage from '../../images/sectoren/msp_image.jpg';

const Sectoren = (props) => {
    // const [filter, setFilter] = useState('ALL');

    const partners = [
        { name: 'MKB', image: MKBImage, category: 'KEY PARTNER' },
        { name: 'Scale-Ups', image: ScaleUpImage, category: 'KEY PARTNER' },
        { name: 'MSP', image: MSPImage, category: 'KEY PARTNER'}
    ];

    // const filteredPartners = filter === 'ALL' ? partners : partners.filter(partner => partner.category === filter);
    const filteredPartners = partners;

    // const handleFilterChange = (category) => {
    //     setFilter(category);
    // };


    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Welke Sectoren geloven in ons?'} bgImage={Bg} />
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-last">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="sectoren_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Het doel om alle sectoren te beveiligen
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Elke sector heeft unieke uitdagingen op het gebied van cybersecurity. Of je nu opereert in de zorg, financiële sector, of technologie, Praeventor biedt oplossingen op maat die jouw organisatie beschermen tegen cyberdreigingen en voldoen aan regelgeving. Ontdek hoe wij jouw sector kunnen versterken.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="pt-130"></div>

                <div className="sectoren_space pb-0" style={{ marginBottom: "200px" }}>
                    <div className="container">
                        {/* Filter Buttons */}
                        {/*<div className="filter-buttons text-center">*/}
                        {/*    <button onClick={() => handleFilterChange('ALL')} className={filter === 'ALL' ? 'active' : ''}>ALL</button>*/}
                        {/*    <button onClick={() => handleFilterChange('KEY PARTNER')} className={filter === 'KEY PARTNER' ? 'active' : ''}>KEY PARTNER</button>*/}
                        {/*    <button onClick={() => handleFilterChange('OTHER')} className={filter === 'OTHER' ? 'active' : ''}>OTHER</button>*/}
                        {/*</div>*/}

                        {/* Partner Grid */}
                        <div className="partner-grid">
                            {filteredPartners.map((partner, index) => (
                                <div key={index} className="partner-card">
                                    <div className="card">
                                        <div className="card-image-wrapper">
                                            <img src={partner.image} alt={`${partner.name} logo`} className="card-img-top" />
                                            {/* Partner name always visible */}
                                            <div className="card-title-overlay">
                                                <h5>{partner.name}</h5>
                                            </div>
                                            {/* Hover-only content */}
                                            <div className="card-hover-overlay">
                                                <a href={`/sectoren/${partner.name.toLowerCase()}`} className="learn-more">
                                                    Lees verder →
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>



                    </div>
                </div>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default Sectoren;
